import * as React from "react";
import CommentModel from "../models/CommentModel";
import RatingModel from "../models/RatingModel";
import Context from "./Context";
import "./CommentRating.styl";

export default class CommentRating extends React.Component<{
    comment: CommentModel;
    rating: RatingModel | null;
}> {

    public render(): React.ReactNode {
        const comment = this.props.comment;
        const rating = this.props.rating;
        return (
            <Context.Consumer>
                {({dispatch, translate}) => (
                    <div className="Discussion-CommentRating-Root">
                        <div className="Discussion-CommentRating-Button" data-type="+" onClick={() => {
                            dispatch("rating", {comment: comment.getCommentId(), type: "+"});
                        }} data-active={(rating && rating.getWeight() > 0) ? "1" : "0"}/>
                        <div className="Discussion-CommentRating-Value" data-type={this.getType(comment.getRating())}>
                            {comment.getRating()}
                        </div>
                        <div className="Discussion-CommentRating-Button" data-type="-" onClick={() => {
                            dispatch("rating", {comment: comment.getCommentId(), type: "-"});
                        }} data-active={(rating && rating.getWeight() < 0) ? "1" : "0"}/>
                    </div>
                )}
            </Context.Consumer>
        );
    }

    private getType(value: number): string {
        if (value > 0) {
            return "+";
        } else if (value < 0) {
            return "-";
        } else {
            return "/";
        }
    }

}